import BaseDialog from "../../modelDialogs/BaseDialog";
import { itx } from "../../translationItx/itx";

export default function ModifyAllTagsToNewTagSystemDialog(props: { newValue: boolean }) {
  const { newValue } = props;
  return (
    <BaseDialog
      onOk={() => {
        state.nameAndTagManager.modifyAllTagsToNewTagSystem(newValue);
        return true;
      }}
      title={itx("consumerPropertyView.adjustNumbering", "Nummerierung anpassen?")}
    >
      <div>
        {itx(
          "modifyAllTagsToNewTagSystemDialog.shouldNumberingAdjust",
          "Sollen vorhandenen Bezeichnungen der neuen Nummerierung angepasst werden?",
        )}
      </div>
    </BaseDialog>
  );
}
